<template>
	<div class="profile-photo" @mouseenter="jingle">
		<Vector :src="photo" class="profile-svg" />
	</div>
</template>
<script>
import Vector from '@/components/abstract/Vector';
import soundFx from '@/mixins/sound-fx';
import { whichAnimationEnd } from '@/mixins/event-detection';

const animationEnd = whichAnimationEnd();

export default {
	name: 'CatProfile',
	components: {
		Vector,
	},
	mixins: [soundFx],
	props: ["photo", "key-prefix"],
	methods: {
		jingle() {
			this.$el.classList.add("jingling");
			if (this.$el.querySelector("g#tag")) {
				this.$el.querySelector("g#tag").addEventListener(animationEnd, this.stopJingle);
			}

			this.playRandomSound("collar_jingles");
		},
		stopJingle() {
			this.$el.querySelector("g#tag").removeEventListener(animationEnd, this.stopJingle);
			this.$el.classList.remove("jingling");
		},
	},
};
</script>

<style lang="scss" scoped>
	.profile-photo {
		display: block;
		position: relative;
		z-index: 99;
		margin: 0 auto;
		transition: all $ui-transition-duration;
	}
</style>
<style lang="scss">
	.profile-svg g#tag, {
		transform-origin: center 72%;
	}

	.jingling .profile-svg g#tag, {
		animation: swing .75s;
	}
</style>



// WEBPACK FOOTER //
// src/components/cat/ProfilePhoto.vue